import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Reseller } from "../../models/Reseller";
import api from "../../api/axios";

interface ResellersState {
    resellers: Reseller[];
    loading: boolean;
    error: string | null;
  }
  
  const initialState: ResellersState = {
    resellers: [],
    loading: false,
    error: null,
  };
  
  // Thunk to fetch resellers
  export const fetchResellers = createAsyncThunk<Reseller[]>(
    'resellers/fetchResellers',
    async (_, thunkAPI) => {
      try {
        const response = await api.get('/User/getResellers');
        return response.data;
      } catch (error: any) {
        return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to load resellers');
      }
    }
  );
  
  const resellersSlice = createSlice({
    name: 'resellers',
    initialState,
    reducers: {
      clearResellers(state) {
        state.resellers = [];
        state.loading = false;
        state.error = null;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchResellers.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchResellers.fulfilled, (state, action: PayloadAction<Reseller[]>) => {
          state.loading = false;
          state.resellers = action.payload;
        })
        .addCase(fetchResellers.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
        });
    },
  });
  
  export const { clearResellers } = resellersSlice.actions;
  export default resellersSlice.reducer;